import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';
import { Text } from '@ui-component-library/components/Text';

import {
  checkboxIconClasses,
  contentClasses,
  hiddenInputClasses,
  labelClasses,
  selectorClasses
} from './Selector.styles';
import type { OptionProps, SelectorProps } from './Selector.types';

export const Selector = ({ children, className }: SelectorProps) => {
  return <div className={cn(selectorClasses(), className)}>{children}</div>;
};

export const Option = ({
  label,
  value,
  showDefaultIcon = false,
  onClick,
  className,
  isSelected = false,
  disabled = false,
  isValid,
  tabIndex = 0,
  children
}: OptionProps) => {
  const handleSelect = () => {
    onClick({ label, value });
  };

  return (
    <label
      className={cn(
        labelClasses({ selected: isSelected, disabled, validationStatus: isValid }),
        className
      )}
    >
      <input
        type="checkbox"
        className={cn(hiddenInputClasses())}
        onChange={handleSelect}
        tabIndex={tabIndex}
        disabled={disabled}
      />
      <div className={cn(contentClasses())}>
        <Text variant="text-sm/leading-normal/medium" className="text[##0F0F0F]">
          {label}
        </Text>
        {children && <>{children}</>}
      </div>
      {!disabled && (
        <Icon
          name={isSelected ? 'CheckSimple' : 'PlusSimple'}
          size="medium"
          className={cn(!showDefaultIcon && checkboxIconClasses({ checked: isSelected }))}
        />
      )}
    </label>
  );
};

Selector.Option = Option;
